import { render, staticRenderFns } from "./statusList.vue?vue&type=template&id=469691b4&"
import script from "./statusList.vue?vue&type=script&lang=js&"
export * from "./statusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports